// extracted by mini-css-extract-plugin
export var defaultWrapper = "_jo-3";
export var downloadButton = "_jo-4";
export var fileContainer = "_jo-9 _jo-7";
export var fileContainerBase = "_jo-7";
export var fileContainerFixedHeight = "_jo-8 _jo-7";
export var fileInfo = "_jo-5";
export var fileInfoWidthRestricted = "_jo-6";
export var fileType = "_jo-1";
export var fileTypeName = "_jo-2";
export var image = "_jo-0";
export var link = "_jo-b";
export var overflowEllipsis = "_jo-a";